import Vue from "vue";

import "@/plugins/config.js";
import "@/services/index.js";
// import {getLCP, getFID, getCLS} from 'web-vitals';
let sdkScriptAdded = false;

Vue.prototype.$sac = new Vue({
  data() {
    return {
      lib: "imply-desk",
      version: "v1.2.1",
      icone: "https://cloudfront.eleventickets.com/omni/sac-atendimento1.png",
      recaptchaAtivo: false,
      sacButton: "",
    };
  },
  methods: {
    init() {
      if (!sdkScriptAdded) {
        var sacImport = document.createElement("script");
        sacImport.type = "text/javascript";
        sacImport.async = true;
        sacImport.src =
          "https://sdk.imply.com/" + this.lib + "-" + this.version + ".min.js";

        localStorage.getItem("sdkSacVersion", this.version);

        // var botao = document.createElement('div');
        // botao.style.position    = 'fixed';
        // botao.style.bottom      = '100px';
        // botao.style.left        = '15px';
        // botao.style.id          = 'botaoSac';
        // botao.style.margin      = '0px 15px';
        // botao.style.cursor      = 'pointer';
        // botao.style.backgroundColor = '#c9c9c9';
        // botao.style.borderRadius = '100%';
        // botao.style.width = '80px';
        // botao.style.height = '80px';
        // botao.style.padding = '0.625rem';

        // // botao.style.transform = 'scale(1.1)';
        // // botao.style.boxShadow = '0px 0px 10px 3px #35353552';
        // botao.style.cursor = 'pointer';

        // botao.id                = 'botaoSAC';
        // botao.innerHTML =
        //     '<a style="display: flex; flex-direction: row; align-items: center;">' +
        //         '<img src="https://cloudfront.eleventickets.com/omni/sac-atendimento5.png" alt width="35">' +
        //     '</a>';
        // botao.addEventListener("click", this.startFlowSac, false);
        // REDUZ O TEMPO DE CARREGAMENTO PARA QUE OS ROBOS DO GOOGLE NÃO FIQUEM APONTANDO CARREGAMENTO

        document.body.insertBefore(
          sacImport,
          document.body.childNodes[document.body.childNodes.length - 1]
            .nextSibling
        );
        let time = setInterval(() => {
          if (window.imply !== undefined) {
            clearInterval(time);
            this.startFlowSac;
          }
        }, 1000);
        setTimeout(() => {
          clearInterval(time);
        }, 10000);
        sdkScriptAdded = true;
      }
    },
    // document.body.insertBefore(botao, document.body.childNodes[document.body.childNodes.length - 1].nextSibling);

    startFlowSac() {
      this.idprojeto = "a2ef9bc2280a76764fa811831f025bb3281f9aca";
      /*
       * lang = def pt, es, en
       * endpoint = http://127.0.0.1:8080 ou externo
       * idprojeto = idprojeto local ou da api
       * corPrimaria = blue, #000000
       * sitekeyRecaptcha = site key do projeto local
       * nome: nome da pessoa logada
       * email: da pessoa logada
       * */
      this.recaptchaAtivo = false;

      var pessoa = this.$axios.getLocal("oe_user_info");

      var params = {
        sitekeyRecaptcha: this.$config.site_key_recaptcha,
        idprojeto: this.idprojeto,
        lang: "pt",
        corPrimaria: this.$config.dados.corterciaria,
        nome: pessoa ? pessoa.data.nome : "",
        email: pessoa ? pessoa.data.email : "",
      };

      // eslint-disable-next-line no-undef, no-unused-vars
      new imply.SAC(params);

      this.sacButton = document.querySelector(".sac-imply-button-close");
    },
    revert() {
      this.recaptchaAtivo = false;
    },
  },
  watch: {
    sacButton() {
      this.sacButton.addEventListener(
        "click",
        () => {
          this.sacButton.addEventListener("click", this.revert(), false);
        },
        false
      );
    },
  },
});

Vue.prototype.$sac.init();
